import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableActionsComponent } from './table-actions.component';
import { WcgButtonComponent } from '@wcg/frontend-framework';
import {
  CreateGridViewComponent,
  GridViewDropDownComponent,
} from '@shared/components/grid-views';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  exports: [TableActionsComponent],
  declarations: [TableActionsComponent],
  imports: [
    CommonModule,
    WcgButtonComponent,
    GridViewDropDownComponent,
    CreateGridViewComponent,
    MatIconModule,
    MatMenuModule,
  ],
})
export class TableActionsModule {}
